import { motion } from 'framer-motion';
import { Volume2, VolumeX } from 'lucide-react';
import { cn } from '../../lib/utils';
import { LogoMark } from '../ui/Logo';
import Avatar from '../ui/Avatar';
import Markdown from './Markdown';

/** A single chat message. Assistant messages render markdown + a TTS button. */
export default function MessageBubble({ message, user, onSpeak, speaking, isStreaming }) {
  const isUser = message.role === 'USER';
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className={cn('flex gap-3', isUser ? 'flex-row-reverse' : 'flex-row')}
    >
      <div className="mt-0.5 shrink-0">
        {isUser ? (
          <Avatar src={user?.avatarUrl} name={user?.name} size={32} />
        ) : (
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-surface-raised">
            <LogoMark className="h-5 w-5" />
          </span>
        )}
      </div>

      <div className={cn('min-w-0 max-w-[80%]', isUser && 'flex flex-col items-end')}>
        <div
          className={cn(
            'rounded-2xl px-4 py-3',
            isUser ? 'bg-brand-500 text-white' : 'glass'
          )}
        >
          {isUser ? (
            <p className="whitespace-pre-wrap text-sm leading-relaxed">{message.content}</p>
          ) : (
            <>
              <Markdown content={message.content || ''} />
              {isStreaming && (
                <span className="ml-0.5 inline-block h-4 w-1.5 translate-y-0.5 animate-pulse rounded-full bg-brand-400" />
              )}
            </>
          )}
        </div>

        {!isUser && message.content && !isStreaming && (
          <button
            onClick={() => onSpeak?.(message)}
            className="mt-1.5 inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs text-content-subtle transition-colors hover:bg-white/5 hover:text-content"
          >
            {speaking ? <VolumeX className="h-3.5 w-3.5" /> : <Volume2 className="h-3.5 w-3.5" />}
            {speaking ? 'Stop' : 'Listen'}
          </button>
        )}
      </div>
    </motion.div>
  );
}
